<template>
  <div class="reservedInstancesSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompanyID"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
          @on-search="searchAccountName()"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="reservedInstanceId"
          :placeholder="$t('RAM.ALI.ReservedInstances.reservedInstanceId')"
          @on-search="searchReservedInstanceId()"
        />
      </Col>
      <Col span="4">
        <Button
                    v-hasPermission="['resourceConfigurationManagement:ali:reservedInstances:page']"
                    @click="getData"
                    >{{ $t("message.select") }}</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil";
import TableReservedInstances from "../reservedInstances/TableReservedInstances";
var tableReservedInstances = TableReservedInstances;
export default {
  name: "ReservedInstancesSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
      reservedInstanceId: "",
    };
  },
  mounted: function () {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableReservedInstances.methods.showAll();
    }
  },
  methods: {
    getData(){
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("reservedInstanceId", this.reservedInstanceId);
      tableReservedInstances.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        this.searchCompany();
      });
    },
    // 切换公司
    changeCompanyID: function () {
      this.searchCompany();
    },
    // 按公司搜索
    searchCompany: function () {
      eventBus.$emit("companyId", this.companyId);
      // tableReservedInstances.methods.showAll();
    },
    // 按账户名称查询
    searchAccountName: function () {
      eventBus.$emit("accountName", this.accountName);
      // tableReservedInstances.methods.showAll();
    },
    // 按账户名称查询
    searchReservedInstanceId: function () {
      eventBus.$emit("reservedInstanceId", this.reservedInstanceId);
      // tableReservedInstances.methods.showAll();
    },
  },
};
</script>
<style scoped>
.reservedInstancesSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/reservedInstances/ReservedInstancesSearch.vue